/* BLUE JEANS STYLE - behaviour layer */
(function () {
  var BJ = (window.BJ = window.BJ || {});
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  BJ.headerOffset = function () {
    var h = document.querySelector('#header-component');
    var top = 0;
    if (h) {
      var r = h.getBoundingClientRect();
      if (r.bottom > 0 && r.top <= 1) top = Math.round(r.bottom);
    }
    document.documentElement.style.setProperty('--bj-sticky-top', top + 'px');
    return top;
  };

  BJ.refreshCartCount = function () {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.documentElement.style.setProperty('--bj-cart-count', '"' + c.item_count + '"');
      document.querySelectorAll('[data-bj-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  };
  var cartTimer;
  document.addEventListener('cart:update', function () { clearTimeout(cartTimer); cartTimer = setTimeout(BJ.refreshCartCount, 300); });

  BJ.addToCart = function (variantId, qty, sourceEl) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
    if (ids.length) fd.append('sections', ids.join(','));
    return fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Error');
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: {}, sourceId: String(variantId), data: { source: 'product-form-component', itemCount: Number(qty || 1), productId: String(res.product_id || ''), sections: res.sections || {} } };
        (sourceEl || document).dispatchEvent(ev);
        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
          else if (!drawer) window.location.href = ROOT + 'cart';
        }, 150);
        return res;
      });
  };

  function initAnnouncement(root) {
    root.querySelectorAll('[data-bj-announcement]').forEach(function (bar) {
      if (bar.__bj) return; bar.__bj = true;
      var items = bar.querySelectorAll('.bj-announcement__item');
      if (items.length < 2) return;
      var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000, t;
      function go(n) { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); }
      function start() { clearInterval(t); if (bar.dataset.autoplay === 'true') t = setInterval(function () { go(i + 1); }, speed); }
      var prev = bar.querySelector('[data-prev]'), next = bar.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { go(i + 1); start(); });
      start();
    });
  }

  function initHero(root) {
    root.querySelectorAll('[data-bj-hero]').forEach(function (hero) {
      if (hero.__bj) return; hero.__bj = true;
      var v = hero.querySelector('video');
      var s = hero.querySelector('.bj-hero__sound');
      if (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if (v && s) s.addEventListener('click', function () { v.muted = !v.muted; s.classList.toggle('is-unmuted', !v.muted); if (v.paused) v.play(); });
      var d = hero.querySelector('.bj-hero__scroll');
      if (d) d.addEventListener('click', function () {
        var sec = hero.closest('.shopify-section');
        var next = sec && sec.nextElementSibling;
        var hh = document.querySelector('#header-component');
        var off = hh ? hh.offsetHeight : 0;
        var y = next ? next.getBoundingClientRect().top + window.scrollY - off : window.innerHeight;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function flash(msg) {
    var n = document.createElement('div');
    n.className = 'bj-toast';
    n.textContent = msg;
    document.body.appendChild(n);
    setTimeout(function () { n.remove(); }, 3500);
  }
  BJ.flash = flash;

  function initQuick(root) {
    root.querySelectorAll('[data-bj-quick]').forEach(function (q) {
      if (q.__bj) return; q.__bj = true;
      var plus = q.querySelector('.bj-pcard__plus');
      var single = q.dataset.single;
      plus.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (single) {
          plus.disabled = true;
          BJ.addToCart(single, 1, q).catch(function (err) { flash(err.message); }).finally(function () { plus.disabled = false; });
          return;
        }
        document.querySelectorAll('.bj-pcard__quick.is-open').forEach(function (o) { if (o !== q) o.classList.remove('is-open'); });
        q.classList.toggle('is-open');
      });
      q.querySelectorAll('[data-variant]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          b.disabled = true;
          BJ.addToCart(b.dataset.variant, 1, q).then(function () { q.classList.remove('is-open'); })
            .catch(function (err) { flash(err.message); }).finally(function () { b.disabled = false; });
        });
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.bj-pcard__quick')) document.querySelectorAll('.bj-pcard__quick.is-open').forEach(function (o) { o.classList.remove('is-open'); });
  });

  function initGallery(root) {
    root.querySelectorAll('[data-bj-gallery]').forEach(function (g) {
      if (g.__bj) return; g.__bj = true;
      var main = g.querySelector('.bj-gallery__main');
      var thumbs = g.querySelectorAll('.bj-gallery__thumbs button');
      var dots = g.querySelectorAll('.bj-gallery__dots span');
      function setActive(i) {
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        dots.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); setActive(i); }); });
      var to;
      main.addEventListener('scroll', function () { clearTimeout(to); to = setTimeout(function () { setActive(Math.round(main.scrollLeft / main.clientWidth)); }, 60); });
      g.bjGoToMedia = function (mediaId) {
        main.querySelectorAll('[data-media-id]').forEach(function (s, i) { if (s.dataset.mediaId == mediaId) { main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); setActive(i); } });
      };
    });
  }

  function money(cents) {
    var fmt = BJ.moneyFormat || '{{amount}}';
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function initProduct(root) {
    root.querySelectorAll('[data-bj-product]').forEach(function (p) {
      if (p.__bj) return; p.__bj = true;
      var dataEl = p.querySelector('[data-bj-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = p.querySelector('form[data-bj-form]');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      var atc = form.querySelector('[data-bj-atc]');
      var atcText = atc.querySelector('span') || atc;
      var priceEl = p.querySelector('[data-bj-price]');
      var err = p.querySelector('.bj-pinfo__error');
      var gallery = p.querySelector('[data-bj-gallery]');
      var sticky = document.querySelector('[data-bj-sticky="' + p.dataset.section + '"]');
      var updateUrl = p.dataset.updateUrl === 'true';
      var first = true;
      function selected() {
        var opts = [];
        p.querySelectorAll('.bj-option').forEach(function (fs) { var c = fs.querySelector('input:checked'); opts.push(c ? c.value : null); });
        return opts;
      }
      function find(opts) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
      function refreshAvailability(opts) {
        p.querySelectorAll('.bj-option').forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = opts.slice(); test[idx] = inp.value;
            var v = find(test);
            var lab = fs.querySelector('label[for="' + inp.id + '"]');
            if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function update() {
        var opts = selected();
        var v = find(opts);
        refreshAvailability(opts);
        if (err) err.classList.remove('is-visible');
        if (!v) { atc.disabled = true; atcText.textContent = atc.dataset.unavailable; return; }
        idInput.value = v.id;
        atc.disabled = !v.available;
        atcText.textContent = v.available ? atc.dataset.add : atc.dataset.soldout;
        if (priceEl) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          var html = '<span class="bj-price__current">' + money(v.price) + '</span>';
          if (onSale) html += '<s>' + money(v.compare_at_price) + '</s>';
          priceEl.innerHTML = html;
          priceEl.classList.toggle('bj-price--sale', !!onSale);
        }
        if (sticky) {
          var sp = sticky.querySelector('[data-bj-price]'); if (sp && priceEl) sp.innerHTML = priceEl.innerHTML;
          var sb = sticky.querySelector('[data-bj-sticky-atc]'); if (sb) { sb.disabled = !v.available; sb.querySelector('span').textContent = atcText.textContent; }
        }
        if (!first && gallery && v.featured_media && gallery.bjGoToMedia) gallery.bjGoToMedia(v.featured_media.id);
        if (!first && updateUrl) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
        first = false;
      }
      p.querySelectorAll('.bj-option input').forEach(function (i) { i.addEventListener('change', update); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        atc.disabled = true;
        var q = form.querySelector('[name="quantity"]');
        BJ.addToCart(idInput.value, q ? q.value : 1, p).catch(function (er) { if (err) { err.textContent = er.message; err.classList.add('is-visible'); } }).finally(function () { update(); });
      });
      if (sticky) {
        var sb = sticky.querySelector('[data-bj-sticky-atc]');
        if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (x) { BJ.headerOffset(); sticky.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); });
        });
        io.observe(atc);
      }
      update();
    });
  }

  function initCollection(root) {
    root.querySelectorAll('[data-bj-collection]').forEach(function (c) {
      if (c.__bj) return; c.__bj = true;
      var grid = c.querySelector('.bj-colgrid');
      var key = 'bj-layout';
      try { var saved = localStorage.getItem(key); if (saved) grid.dataset.layout = saved; } catch (e) {}
      function mark() { c.querySelectorAll('[data-layout-btn]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.layoutBtn === grid.dataset.layout); }); }
      c.querySelectorAll('[data-layout-btn]').forEach(function (b) {
        b.addEventListener('click', function () { grid.dataset.layout = b.dataset.layoutBtn; mark(); try { localStorage.setItem(key, grid.dataset.layout); } catch (e) {} });
      });
      mark();
      var sort = c.querySelector('[data-bj-sort]');
      if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.bj-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init(root) {
    root = root || document;
    initAnnouncement(root); initHero(root); initQuick(root); initGallery(root);
    initProduct(root); initCollection(root); initReveal(root);
    BJ.headerOffset();
  }
  BJ.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('resize', BJ.headerOffset);
  window.addEventListener('scroll', BJ.headerOffset, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
